import { useState } from 'react'
import { useAuth } from './context/AuthContext'
import { Layout } from './components/Layout'
import { Login } from './pages/Login'
import { AdminDashboard } from './pages/admin/AdminDashboard'
import { AdminUsers } from './pages/admin/AdminUsers'
import { AdminStrategies } from './pages/admin/AdminStrategies'
import { AdminExecutions } from './pages/admin/AdminExecutions'
import { AdminBrokers } from './pages/admin/AdminBrokers'
import { AdminReports } from './pages/admin/AdminReports'
import { AdminSettings } from './pages/admin/AdminSettings'
import { AdminOpsCenter } from './pages/admin/AdminOpsCenter'
import { TraderDashboard } from './pages/trader/TraderDashboard'
import { TraderLiveWatch } from './pages/trader/TraderLiveWatch'
import { TraderReports } from './pages/trader/TraderReports'
import { TraderStrategies } from './pages/trader/TraderStrategies'
import { TraderArchived } from './pages/trader/TraderArchived'
import { TraderOrderBook } from './pages/trader/TraderOrderBook'
import { KnowledgeBase } from './pages/KnowledgeBase'
import { CircuitBreakerModal } from './components/CircuitBreakerModal'
import type { PageView } from './types'

export function App() {
  const { session } = useAuth()
  const [view, setView] = useState<PageView>('login')

  if (!session) return <Login />

  const isAdmin = session.user.role === 'admin'

  const renderView = () => {
    if (isAdmin) {
      switch (view) {
        case 'admin-dashboard': return <AdminDashboard onNavigate={setView} />
        case 'admin-users': return <AdminUsers />
        case 'admin-strategies': return <AdminStrategies />
        case 'admin-executions': return <AdminExecutions />
        case 'admin-brokers': return <AdminBrokers />
        case 'admin-reports': return <AdminReports />
        case 'admin-settings': return <AdminSettings onNavigate={setView} />
        case 'admin-logs': return <AdminOpsCenter />
        case 'trader-livewatch': return <TraderLiveWatch />
        case 'knowledge': return <KnowledgeBase />
        default: return <AdminDashboard onNavigate={setView} />
      }
    } else {
      switch (view) {
        case 'trader-dashboard': return <TraderDashboard onNavigate={setView} />
        case 'trader-livewatch': return <TraderLiveWatch />
        case 'trader-reports': return <TraderReports />
        case 'trader-strategies': return <TraderStrategies />
        case 'trader-archived': return <TraderArchived />
        case 'trader-orderbook': return <TraderOrderBook />
        default: return <TraderDashboard onNavigate={setView} />
      }
    }
  }

  return (
    <Layout view={view} onNavigate={setView}>
      {renderView()}
      {/* Global Circuit Breaker modal — shown on any page when CB trips */}
      <CircuitBreakerModal />
    </Layout>
  )
}
